import React, { useEffect, useState } from 'react';

// External Components
import RangeSlider from 'react-range-slider-input';
import Decimal from 'decimal.js';

// Styles
import { StyledAPTCSliderContainer } from './plansummary.styled';

// Common Components
import { CurrencyInput } from '../../../components/common/form';
import { ConditionalRendering } from '../../../components/common/conditional-rendering';

// Constants
import { INPUT_TYPES } from '../../../constants/inputs/inputTypes';
import { ARROWDIRECTION } from '../../../components/common/button/StepArrowButtons';

// Hooks
import { useAptcContext } from './hooks/useAptcContext';
import { REGEX } from '../../../constants/common/regex';

const MAX_INTEGER_LENGTH = 10;
const MAX_DECIMAL_LENGTH = '2';
const MAX_SLIDER_VALUE = 100;
const STEP_VALUE = 0.01;

const APTCSlider = ({ maxAptc = MAX_SLIDER_VALUE }) => {
    const { newAptc, setNewAptc } = useAptcContext();
    const [aptcInput, setAptcInput] = useState(`${newAptc}`);
    const [key, setKey] = useState(Math.random());

    useEffect(() => {
        if (aptcInput !== `${newAptc}`) {
            setNewAptc(Number(aptcInput));
        }
    }, [aptcInput]);

    const handleInputChange = e => {
        const value = e.target.value;
        const isValidInputRange = value >= 0;
        if (value === '' || REGEX.TWO_DECIMAL_INPUT_VALUE.test(value) && isValidInputRange) {
            setAptcInput(value);
        }
    };

    const handleStepChange = (key) => {
        setAptcInput((prev) => {
            const decimalValue = new Decimal(prev);
            const value = key === ARROWDIRECTION.UP ? decimalValue.plus(STEP_VALUE).toNumber() : decimalValue.minus(STEP_VALUE).toNumber();
            const isValidInputRange = value <= maxAptc && value >= 0;
            if (REGEX.TWO_DECIMAL_INPUT_VALUE.test(value.toString()) && isValidInputRange) {
                return value.toString();
            }
            else {
                setKey(Math.random());
                return prev;
            }
        });
    };

    return (
        <StyledAPTCSliderContainer as="div">
            <CurrencyInput
                key={key}
                // @ts-ignore
                label={{
                    wrapperClasses: ['currency-input'],
                    labelClasses: [''],
                    labelText: '',
                    showRequired: false,
                    isInputRequired: false,
                }}
                input={{
                    id: 'electedAptc',
                    isInputRequired: true,
                    type: INPUT_TYPES.TEXT,
                    value: aptcInput,
                    dataTestId: 'electedAptc',
                    name: 'electedAptc',
                    placeholder: '',
                    autocomplete:'off'
                }}
                actions={{
                    handleChange: value => handleInputChange(value),
                    handleStepChange: key => handleStepChange(key)
                }}
                maskOptions={{
                    allowDecimal: true,
                    prefix: '',
                    decimalLimit: MAX_DECIMAL_LENGTH,
                    integerLimit: MAX_INTEGER_LENGTH,
                    includeThousandsSeparator: false,
                    allowLeadingZeroes: true,
                }}
                showIcon={true}
                hasLargeInput={true}
                isStepArrowsVisible={true}
            />
            <div style={{ flex: 1 }}>
                <RangeSlider
                    id="aptc-slider"
                    rangeSlideDisabled={true}
                    defaultValue={[0, Number(aptcInput)]}
                    value={[0, Number(aptcInput)]}
                    thumbsDisabled={[true, false]}
                    max={maxAptc}
                    step={0.01}
                    onInput={e => setAptcInput(e[1].toFixed(2))}
                />
            </div>
            <p className="val" id="aptc-credit" data-testid="aptc-credit">
                <ConditionalRendering isTrue={maxAptc - newAptc >= 0}>
                    {new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(maxAptc - newAptc)}
                </ConditionalRendering>
            </p>
        </StyledAPTCSliderContainer>
    );
};

export default APTCSlider;
